import { Button, Input } from "@RooUI";
import React from "react";

import { HearAboutRooSelect } from "../../../Common/Form/HearAboutRooSelect";
import { FormContainer, FormFieldTwoColumnGrid, FormFields } from "../Common/styles";
import { ButtonContainer } from "../RegistrationPageContainer/styles";

import { useFormContext } from "./RegistrationReferralFormContext";
import { useGetHasSelectedReferralOption } from "./service";

export const RegistrationReferralForm = () => {
  const { onChange, onSave, loading, errors, form } = useFormContext();
  const { getHasSelectedReferralOption } = useGetHasSelectedReferralOption();

  const { hearAboutRoo, referralCode } = form
    ? form
    : { hearAboutRoo: undefined, referralCode: undefined };
  const hasSelectedReferralOption = getHasSelectedReferralOption(hearAboutRoo ?? -1);

  return (
    <FormContainer>
      <FormFields>
        <FormFieldTwoColumnGrid>
          <HearAboutRooSelect
            value={hearAboutRoo}
            onChange={(option) => {
              if (onChange) {
                onChange("hearAboutRoo", option.value);
              }
            }}
            error={errors?.["hearAboutRoo"]}
            data-testid="rooReferences"
            searchable
          />
          {hasSelectedReferralOption && (
            <Input
              label="Referral code"
              value={referralCode}
              disabled={!hasSelectedReferralOption}
              onChange={(e) => {
                if (onChange) {
                  onChange("referralCode", e.target.value);
                }
              }}
              error={errors?.["referralCode"]}
              data-testid="referralCodeInput"
            />
          )}
        </FormFieldTwoColumnGrid>
      </FormFields>
      <ButtonContainer>
        <Button
          $buttonType="primary"
          title="See Shifts"
          onClick={onSave}
          loading={loading}
          data-testid="seeShiftsBtn"
        />
      </ButtonContainer>
    </FormContainer>
  );
};
